'use client'

import { HOUSE_TYPE_ID } from '@config'
import { first, join } from 'lodash-es'
import { createContext, useContext, useState } from 'react'

export const OfficeListingsContext = createContext()
export function useOfficeListingsContext() {
  return useContext(OfficeListingsContext)
}
export const OfficeListingsTypes = [
  {label: 'For sale', event: 'click_for_sale', value: join([HOUSE_TYPE_ID.residential, HOUSE_TYPE_ID['commercial-property-for-lease'], HOUSE_TYPE_ID.rural, HOUSE_TYPE_ID['businesses-for-sale']], ',')},
  {label: 'Sold', event: 'click_for_sold', value: -102},
  {label: 'For lease', event: 'click_for_lease', value: HOUSE_TYPE_ID['commercial-property-for-lease']},
  {label: 'For rent', event: 'click_for_rent', value: HOUSE_TYPE_ID.rent},
]

export default function OfficeListingsProvider({
  children
}) {

  const [pageIndex, setPageIndex] = useState(1)
  const [type, setType] = useState(first(OfficeListingsTypes))

  return (
    <OfficeListingsContext.Provider value={{ pageIndex, setPageIndex, type, setType }}>
      {children}
    </OfficeListingsContext.Provider>
  )
}